const API_BASE_URL = 'https://mmstudio.co.kr:10444';

// 마지막 거래일 가져오기
export const getLastRunDate = async (ticker) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/run-date`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.runDate;
  } catch (error) {
    console.error('Error fetching last run date:', error);
    // 에러 시 오늘 날짜 반환
    return new Date().toISOString().split('T')[0];
  }
};

const getRunDate = () => {
  // return '2025-07-18'; // Fixed date for now 2
  const today = new Date().toISOString().split('T')[0];
  return today; // Use today's date
};

export const getInvestmentRecommendation = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/investment-recommendation?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching investment recommendation:', error);
    throw error;
  }
};

export const getNewsAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/news?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching news analysis:', error);
    throw error;
  }
};

export const getRiskAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/risk?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching risk analysis:', error);
    throw error;
  }
};

export const getSentimentAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/sentiment?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching sentiment analysis:', error);
    throw error;
  }
};

export const getTechnicalAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/technical?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching technical analysis:', error);
    throw error;
  }
};

export const getFundamentalAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/summary-report/${ticker}/fundamental?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching fundamental analysis:', error);
    throw error;
  }
};

export const getStockDetailFundamental = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/fundamental?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock detail fundamental:', error);
    throw error;
  }
};

export const getStockDetailTechnical = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/technical?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock detail technical:', error);
    throw error;
  }
};

export const getStockDetailNews = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/news?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock detail news:', error);
    throw error;
  }
};

export const getStockDetailSummary = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/summary?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching stock detail summary:', error);
    throw error;
  }
};

export const getStockScoreHistory = async (ticker) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/score`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock score history:', error);
    throw error;
  }
};

export const getInvestmentReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/investment-recommendation?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching investment report:', error);
    throw error;
  }
};

export const getNewsReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/news?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching news report:', error);
    throw error;
  }
};

export const getTechnicalReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/technical?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching technical report:', error);
    throw error;
  }
};

export const getFundamentalReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/fundamental?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching fundamental report:', error);
    throw error;
  }
};

export const getSentimentReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/sentiment?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching sentiment report:', error);
    throw error;
  }
};

export const getRiskReport = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/report/${ticker}/risk?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching risk report:', error);
    throw error;
  }
};

export const getDashboardMainContent = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/dashboard-main-content`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching dashboard main content:', error);
    throw error;
  }
};

export const getDashboardMarketData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/dashboard-market-data`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching dashboard market data:', error);
    throw error;
  }
};

export const getSearchTickers = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/search/tickers`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching search tickers:', error);
    throw error;
  }
};

export const searchStocks = async (query) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/search?query=${encodeURIComponent(query)}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error searching stocks:', error);
    throw error;
  }
};

export const getStockDetailCommunity = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/community?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock detail community:', error);
    throw error;
  }
};

export const getShortPositionAnalysis = async (ticker, runDate) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/analysis/short-position/${ticker}?runDate=${runDate}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching short position analysis:', error);
    throw error;
  }
};

// 즐겨찾기 목록 가져오기
export const getFavoriteList = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/auth/favorite`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching favorite list:', error);
    throw error;
  }
};

// 즐겨찾기 추가/삭제 (통합 API)
export const toggleFavorite = async (ticker, isFavorite) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/auth/favorite`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ticker, isFavorite })
    });
    
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error toggling favorite:', error);
    throw error;
  }
};

// 하위 호환성을 위한 래퍼 함수들
export const addFavorite = async (ticker) => {
  return await toggleFavorite(ticker, true);
};

export const deleteFavorite = async (ticker) => {
  return await toggleFavorite(ticker, false);
};

// ===== Community APIs =====

// 쿠키에서 값 읽기 헬퍼
const getCookieValue = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

// 쿠키에서 accessToken 가져오기 (HttpOnly 쿠키는 읽기 불가 → localStorage 폴백)
export const getAccessToken = () => {
  return getCookieValue('accessToken') || localStorage.getItem('accessToken') || null;
};

// 쿠키에서 refreshToken 가져오기 (HttpOnly 쿠키는 읽기 불가 → localStorage 폴백)
export const getRefreshToken = () => {
  return getCookieValue('refreshToken') || localStorage.getItem('refreshToken') || null;
};

// JWT 만료 여부 확인 (exp 클레임 기준)
export const isTokenExpired = (token) => {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return true;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    if (!payload.exp) return true;
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

// refreshToken 기준으로 OAuth 가입자 여부 판단
// refreshToken 있고 만료 안됨 → OAuth 가입자
// refreshToken 없거나 만료됨 → 둘러보기(게스트)
export const isOAuthUser = () => {
  const token = getRefreshToken();
  if (!token) return false;
  return !isTokenExpired(token);
};

// ===== Token Refresh =====

// 동시에 여러 API가 401을 받아도 갱신 요청은 한 번만 보내도록 관리
// ===== Native RefreshToken 인터페이스 (export 버전) =====

export const getNativeRefreshToken = () => {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => resolve(null), 3000);

    window.receiveRefreshToken = function (token) {
      clearTimeout(timeout);
      window.receiveRefreshToken = null;
      if (token) {
        document.cookie = `refreshToken=${encodeURIComponent(token)}; path=/; SameSite=None; Secure`;
        localStorage.setItem('refreshToken', token);
      }
      resolve(token || null);
    };

    if (window.webkit?.messageHandlers?.getRefreshToken) {
      // iOS
      window.webkit.messageHandlers.getRefreshToken.postMessage(null);
    } else if (window.getRefreshToken) {
      // Android
      window.getRefreshToken.postMessage('');
    } else {
      clearTimeout(timeout);
      resolve(null);
    }
  });
};

export const updateNativeRefreshToken = (refreshToken) => {
  if (window.webkit?.messageHandlers?.updateRefreshToken) {
    window.webkit.messageHandlers.updateRefreshToken.postMessage({ refreshToken }); // iOS
  } else if (window.updateRefreshToken) {
    window.updateRefreshToken.postMessage(refreshToken); // Android
  }
};

// 네이티브(iOS/Android)에서 refreshToken을 가져와 localStorage에 저장
// initAuth 등 앱 진입 시점에 한 번 호출
export const initNativeToken = async () => {
  const platform = getPlatform();
  if (platform !== 'ios' && platform !== 'android') return;

  await getNativeRefreshToken(); // 내부 receiveRefreshToken 콜백에서 쿠키 + localStorage 저장 처리
};

export const deleteNativeRefreshToken = () => {
  if (window.webkit?.messageHandlers?.deleteRefreshToken) {
    window.webkit.messageHandlers.deleteRefreshToken.postMessage(null); // iOS
  } else if (window.deleteRefreshToken) {
    window.deleteRefreshToken.postMessage(''); // Android
  }
};

export const hideNativeTabBar = () => {
  if (window.webkit?.messageHandlers?.hideTabBar) {
    window.webkit.messageHandlers.hideTabBar.postMessage(null); // iOS
  } else if (window.hideTabBar) {
    window.hideTabBar.postMessage(''); // Android
  }
};

export const showNativeTabBar = () => {
  if (window.webkit?.messageHandlers?.showTabBar) {
    window.webkit.messageHandlers.showTabBar.postMessage(null); // iOS
  } else if (window.showTabBar) {
    window.showTabBar.postMessage(''); // Android
  }
};

// ===== 외부 URL 열기 네이티브 인터페이스 =====
export const openExternalUrl = (url) => {
  if (window.webkit?.messageHandlers?.openExternalUrl) {
    window.webkit.messageHandlers.openExternalUrl.postMessage(url); // iOS
  } else if (window.openExternalUrl) {
    window.openExternalUrl.postMessage(url); // Android
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

// ===== 앱 리뷰 요청 네이티브 인터페이스 =====
export const requestAppReview = () => {
  if (window.webkit?.messageHandlers?.requestAppReview) {
    window.webkit.messageHandlers.requestAppReview.postMessage(null); // iOS
  } else if (window.requestAppReview) {
    window.requestAppReview.postMessage(''); // Android
  }
};

// ===== 네이티브 스토리지 인터페이스 =====
export const setNativeStorage = (key, value) => {
  const payload = JSON.stringify({ key, value });
  if (window.webkit?.messageHandlers?.setNativeStorage) {
    window.webkit.messageHandlers.setNativeStorage.postMessage(payload); // iOS
  } else if (window.setNativeStorage) {
    window.setNativeStorage.postMessage(payload); // Android
  }
};

export const getNativeStorage = (key) => {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => resolve(null), 3000);
    window.receiveNativeStorage = function (value) {
      clearTimeout(timeout);
      window.receiveNativeStorage = null;
      resolve(value ?? null);
    };
    const payload = JSON.stringify({ key });
    if (window.webkit?.messageHandlers?.getNativeStorage) {
      window.webkit.messageHandlers.getNativeStorage.postMessage(payload); // iOS
    } else if (window.getNativeStorage) {
      window.getNativeStorage.postMessage(payload); // Android
    } else {
      clearTimeout(timeout);
      resolve(null);
    }
  });
};

// ===== 푸시 알림 네이티브 인터페이스 =====

// 웹 → 네이티브: 푸시 알림 권한 요청 (fire-and-forget)
// 네이티브가 OS 권한 다이얼로그를 띄운다. 승인 시 네이티브가 토큰을 발급.
// 웹 → 네이티브: 푸시 알림 권한 요청 (비동기, 콜백 방식)
// 시스템 다이어로그에 사용자가 응답한 후 네이티브가 window.receivePushPermissionResult(granted) 를 호출해줘야 함
// 웹 환경 등 네이티브 핸들러가 없으면 즉시 null resolve (fallback)
export const requestPushPermission = () => {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => resolve(null), 60000); // 사용자가 시스템 다이어로그에 응답할 시간을 넉넉히 허용
    window.receivePushPermissionResult = function (granted) {
      clearTimeout(timeout);
      window.receivePushPermissionResult = null;
      resolve(granted === true || granted === 'true');
    };
    if (window.webkit?.messageHandlers?.requestPushPermission) {
      window.webkit.messageHandlers.requestPushPermission.postMessage(null); // iOS
    } else if (window.requestPushPermission) {
      window.requestPushPermission.postMessage(''); // Android
    } else {
      clearTimeout(timeout);
      resolve(null);
    }
  });
};

// 웹 → 네이티브: 현재 푸시 알림 권한 상태 요청 (비동기, 콜백 방식)
// 네이티브가 window.receivePushPermissionStatus(status) 를 호출해줘야 함
// status 예: 'granted' | 'denied' | 'notDetermined'
// 웹 환경 등 네이티브 핸들러가 없으면 즉시 null resolve (fallback)
export const getPushPermissionStatus = () => {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => resolve(null), 3000);
    window.receivePushPermissionStatus = function (status) {
      clearTimeout(timeout);
      window.receivePushPermissionStatus = null;
      resolve(status || null);
    };
    if (window.webkit?.messageHandlers?.getPushPermissionStatus) {
      window.webkit.messageHandlers.getPushPermissionStatus.postMessage(null); // iOS
    } else if (window.getPushPermissionStatus) {
      window.getPushPermissionStatus.postMessage(''); // Android
    } else {
      clearTimeout(timeout);
      resolve(null);
    }
  });
};

let refreshPromise = null;

// refreshToken으로 accessToken / refreshToken 갱신
export const refreshAccessToken = async () => {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) throw new Error('No refresh token');

    const response = await fetch(`${API_BASE_URL}/api/v1/open/auth/token`, {
      method: 'POST',
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${refreshToken}`
      }
    });

    if (!response.ok) throw new Error('Token refresh failed');

    const data = await response.json();

    // 새 토큰 저장 (쿠키 + localStorage)
    document.cookie = `accessToken=${encodeURIComponent(data.accessToken)}; path=/; SameSite=None; Secure`;
    document.cookie = `refreshToken=${encodeURIComponent(data.refreshToken)}; path=/; SameSite=None; Secure`;
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);

    // 앱(iOS/Android)에도 새 refreshToken 저장
    const platform = getPlatform();
    if (platform === 'ios' || platform === 'android') {
      updateNativeRefreshToken(data.refreshToken);
    }

    return data.accessToken;
  })().finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
};

// 인증이 필요한 fetch wrapper
// 401 응답 시 → 토큰 갱신 → 원래 요청 재시도
const fetchWithAuth = async (url, options = {}) => {
  const makeRequest = (token) => fetch(url, {
    ...options,
    headers: {
      'accept': '*/*',
      ...options.headers,
      'Authorization': `Bearer ${token}`
    }
  });

  const response = await makeRequest(getAccessToken());

  if (response.status === 401) {
    try {
      const newToken = await refreshAccessToken();
      return makeRequest(newToken);
    } catch {
      if (isOAuthUser()) {
        window.deleteOAuthToken?.();
        window.location.href = '/login?reason=token_expired';
      }
      throw new Error('Session expired');
    }
  }

  return response;
};

// 플랫폼 감지: 'ios' | 'android' | 'web'
export const getPlatform = () => {
  const ua = navigator.userAgent || '';
  if (/mmStudio\/iOS/i.test(ua)) return 'ios';
  if (/mmStudio\/AOS/i.test(ua)) return 'android';
  return 'web';
};

// 앱 버전 요청 (네이티브 → window.receiveAppVersion(version) 콜백)
export const getAppVersion = () =>
  new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), 3000);
    window.receiveAppVersion = (version) => {
      clearTimeout(timer);
      window.receiveAppVersion = null;
      resolve(version || null);
    };
    if (window.webkit?.messageHandlers?.getAppVersion) {
      window.webkit.messageHandlers.getAppVersion.postMessage(null); // iOS
    } else if (window.getAppVersion) {
      window.getAppVersion.postMessage(''); // Android
    } else {
      clearTimeout(timer);
      resolve(null);
    }
  });

// 버전 비교: version이 minVersion 미만이면 true ('1.9.0' < '2.0.0' → true)
export const isVersionBelow = (version, minVersion) => {
  if (!version) return false;
  const a = version.split('.').map(Number);
  const b = minVersion.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    if ((a[i] || 0) < (b[i] || 0)) return true;
    if ((a[i] || 0) > (b[i] || 0)) return false;
  }
  return false;
};

// ===== Native Interface Handlers =====
// 네이티브(iOS/Android)에서 직접 호출하는 JavaScript 인터페이스

if (typeof window !== 'undefined') {
  // ===== RefreshToken 네이티브 인터페이스 =====

  // 웹 → 네이티브: refreshToken 요청 (비동기, 콜백 방식)
  // 네이티브가 값을 읽은 후 window.receiveRefreshToken(token) 을 호출해줘야 함
  window.getNativeRefreshToken = getNativeRefreshToken;

  // 웹 → 네이티브: refreshToken 저장 요청
  window.updateNativeRefreshToken = updateNativeRefreshToken;

  // 웹 → 네이티브: refreshToken 삭제 요청
  window.deleteNativeRefreshToken = deleteNativeRefreshToken;

  // 네이티브 → 웹: accessToken 쿠키 조회
  window.getOAuthToken = function () {
    return getCookieValue('accessToken');
  };

  // 네이티브 → 웹: accessToken / refreshToken 저장 (쿠키 + localStorage)
  window.updateOAuthToken = function (accessToken, refreshToken) {
    document.cookie = `accessToken=${encodeURIComponent(accessToken)}; path=/; SameSite=None; Secure`;
    localStorage.setItem('accessToken', accessToken);
    if (refreshToken) {
      document.cookie = `refreshToken=${encodeURIComponent(refreshToken)}; path=/; SameSite=None; Secure`;
      localStorage.setItem('refreshToken', refreshToken);
    }
  };

  // 네이티브 → 웹: accessToken / refreshToken 삭제 (쿠키 + localStorage)
  window.deleteOAuthToken = function () {
    document.cookie = 'accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('oauthLoggedIn');
  };

  // ===== 네이티브 → 웹 탭 네비게이션 =====
  // 네이티브 탭 탭 시 window.navigateTo(path) 호출 → React Router 라우팅
  window.navigateTo = function (path, direction) {
    const state = {};
    if (direction === 'back') state._navDirection = 'back';
    window.__navigate?.(path, { state });
  };
}

// 커뮤니티 게시글 목록 가져오기
export const getCommunityPosts = async (cursor = null) => {
  try {
    const url = cursor 
      ? `${API_BASE_URL}/api/v1/open/community?cursor=${cursor}`
      : `${API_BASE_URL}/api/v1/open/community`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch community posts');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching community posts:', error);
    throw error;
  }
};

// 댓글 목록 가져오기
export const getCommunityReplies = async (communityNo) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/community/reply?communityNo=${communityNo}`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch replies');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching replies:', error);
    throw error;
  }
};
export const getUserInfo = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/user`, {
      method: 'GET',
      headers: { 
        'accept': '*/*',
        'Authorization': `Bearer ${getAccessToken()}`
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user info');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching user info:', error);
    throw error;
  }
};

// ===== 푸시 알림 서버 API =====
// FCM 토큰 등록(POST /api/v1/user/fcm-tokens)은 네이티브(AppDelegate.registerFCMToken)가 전담 — 웹은 동의 여부만 관리

// 푸시 수신 동의 여부 변경 (서버가 동의 상태에 따라 토큰 보관/삭제를 알아서 처리함)
// 응답 예: { pushAgreeYn }
export const updatePushConsent = async (pushAgreeYn) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/user/push-consent`, {
      method: 'PUT',
      headers: {
        'accept': '*/*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAccessToken()}`
      },
      body: JSON.stringify({ pushAgreeYn })
    });

    if (!response.ok) {
      throw new Error('Failed to update push consent');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating push consent:', error);
    return null;
  }
};

// HttpOnly 쿠키 기반 토큰 유효성 검증
// 200 → 유효, 401 → 만료/없음
export const validateToken = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/user`, {
      method: 'GET',
      headers: { 'accept': '*/*' },
      credentials: 'include'
    });
    return response.ok;
  } catch {
    return false;
  }
};

// 게시글/댓글 작성
export const submitCommunityPost = async (content, parentCommunityNo = null) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/auth/community`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content: content.trim(),
        parentCommunityNo: parentCommunityNo || 0
      })
    });

    if (!response.ok) throw new Error('Failed to submit post');
    return await response.json();
  } catch (error) {
    console.error('Error submitting post:', error);
    throw error;
  }
};

// X 트윗 데이터 가져오기
export const getXTweetData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/x`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching X tweet data:', error);
    throw error;
  }
};

// 공포 탐욕 지수 가져오기 (history API의 list[0] = 최신값 사용)
export const getFearGreedIndex = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/fear-and-greed-index/history`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const list = Array.isArray(data?.list) ? data.list : [];
    const latest = list[0];
    return {
      fearAndGreed: latest
        ? { score: latest.score, rating: latest.rating, KST: latest.timestampKst }
        : null,
      history: list,
    };
  } catch (error) {
    console.error('Error fetching fear and greed index:', error);
    throw error;
  }
};

// FRED 거시경제 9개 지표 기반 경기 침체 위험 점수
export const getFredRecessionScore = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/fred-recession-score`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching FRED recession score:', error);
    throw error;
  }
};

// 공포 탐욕 지수 히스토리 가져오기 (size 미지정 시 백엔드 기본값, 기본 30개)
export const getFearGreedHistory = async (size) => {
  try {
    const url = size
      ? `${API_BASE_URL}/api/v1/open/dashboard/fear-and-greed-index/history?size=${size}`
      : `${API_BASE_URL}/api/v1/open/dashboard/fear-and-greed-index/history`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching fear and greed history:', error);
    throw error;
  }
};

// 주식 랭킹 가져오기
export const getStockRanking = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/stock-ranking`, {
      method: 'GET',
      headers: {
        'accept': '*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching stock ranking:', error);
    throw error;
  }
};

export const withdrawUser = async () => {
  const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/user/withdraw`, {
    method: 'POST',
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${getAccessToken()}`
    },
  });

  if (!response.ok) {
    throw new Error('회원 탈퇴에 실패했습니다.');
  }

  return response;
};

// AI 아티클 목록 가져오기
export const getArticleList = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/article`, {
      method: 'GET',
      headers: { 'accept': '*/*' },
    });
    if (!response.ok) throw new Error('Failed to fetch articles');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching article list:', error);
    return { list: [] };
  }
};

// ===== AI 거장 토론 (AI Debate) =====
// 목록 응답: { list: [{ aiDebateNo, title, keyword, updatedAt }], totalCount }
export const getDebateList = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/ai-debate`, {
      method: 'GET',
      headers: { 'accept': '*/*' },
    });
    if (!response.ok) throw new Error('Failed to fetch ai-debates');
    return await response.json();
  } catch (error) {
    console.warn('AI debate list API unavailable, trying static manifest:', error.message);
    try {
      const res = await fetch('/debates/index.json');
      if (!res.ok) throw new Error('manifest missing');
      return await res.json();
    } catch (e) {
      console.error('Static debate manifest also missing:', e.message);
      return { list: [], totalCount: 0 };
    }
  }
};

// 상세 응답: { aiDebateNo, title, keyword, rawData: <chat/1.0>, updatedAt }
// 컴포넌트가 직접 사용하는 chat/1.0 본문(rawData)을 언래핑해서 반환
export const getDebateDetail = async (aiDebateNo) => {
  if (!aiDebateNo) return null;
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/ai-debate/${aiDebateNo}`, {
      method: 'GET',
      headers: { 'accept': '*/*' },
    });
    if (!response.ok) throw new Error('Failed to fetch ai-debate detail');
    const data = await response.json();
    // 백엔드: rawData에 chat/1.0이 들어 있음. 정적 fallback: chat/1.0이 root에 위치.
    return data?.rawData || data;
  } catch (error) {
    console.warn(`AI debate detail API unavailable (${aiDebateNo}), trying static fallback:`, error.message);
    try {
      const res = await fetch(`/debates/debate_${aiDebateNo}.json`);
      if (!res.ok) throw new Error('static missing');
      const data = await res.json();
      return data?.rawData || data;
    } catch (e) {
      console.error('Static debate fallback also missing:', e.message);
      return null;
    }
  }
};

// ===== 임원 학력 지수 =====

const getExecutiveEduTierLabel = (score) => {
  if (score >= 50) return '최상위 명문대';
  if (score >= 30) return '명문대 집중';
  if (score >= 20) return '우수 대학';
  if (score >= 10) return '중상위 대학';
  if (score >= 5) return '일반 대학';
  return '다양한 배경';
};

export const getExecutiveEduScore = async (ticker) => {
  if (!ticker) return null;

  const cacheKey = `exec_edu_${ticker.toUpperCase()}`;

  try {
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) return JSON.parse(cached);
  } catch {}

  try {
    const res = await fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/executive-education`);
    if (!res.ok) return null;
    const data = await res.json();

    const execs = data.executives ?? [];

    const mappedExecs = execs
      .map((exec) => {
        const bestTier = (exec.schoolTiers ?? []).reduce(
          (best, t) => (t.score > (best?.score ?? -1) ? t : best),
          null
        );
        return {
          name: exec.name,
          title: exec.title ?? '',
          school: bestTier?.school ?? exec.schools?.[0] ?? '',
          tier: bestTier?.tier ?? '기타',
          schoolScore: bestTier?.score ?? 0,
        };
      })
      .filter((e) => e.school);

    const allTiers = execs.flatMap((e) => e.schoolTiers ?? []);
    const topEntry = allTiers.reduce(
      (best, t) => (t.score > (best?.score ?? -1) ? t : best),
      null
    );

    const score = data.educationScore?.score ?? 0;
    const result = {
      score,
      executiveCount: execs.length,
      topSchool: topEntry?.school ?? null,
      tier: getExecutiveEduTierLabel(score),
      executives: mappedExecs.slice(0, 5),
    };

    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(result));
    } catch {}

    return result;
  } catch (error) {
    console.error('getExecutiveEduScore: unexpected error', error);
    return null;
  }
};

// ===== Reddit Trends =====

// Reddit 트렌딩 종목 가져오기 (오픈 API, 인증 불필요)
export const getRedditTrending = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/v1/open/dashboard/reddit-trends?page=1`,
      {
        method: 'GET',
        headers: {
          accept: '*/*',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const results = Array.isArray(data?.results) ? data.results : [];

    return results.map((item) => {
      const rank = Number(item.rank) || 0;
      const rank24hAgo =
        item.rank_24h_ago !== null && item.rank_24h_ago !== undefined
          ? Number(item.rank_24h_ago)
          : rank;
      // 양수 = 순위 상승 (rank 숫자가 작아짐)
      const rankChange = rank24hAgo - rank;

      const mentions = Number(item.mentions) || 0;
      const mentions24hAgo = Number(item.mentions_24h_ago) || 0;
      const mentionChangePct = mentions24hAgo
        ? ((mentions - mentions24hAgo) / mentions24hAgo) * 100
        : 0;

      return {
        ...item,
        rank,
        rankChange,
        mentionChangePct,
      };
    });
  } catch (error) {
    console.error('Error fetching reddit trending:', error);
    return [];
  }
};

// 특정 종목의 Reddit 버즈 단일 객체 반환 (StockDetailPage용)
export const getRedditBuzz = async (ticker) => {
  if (!ticker) return null;

  try {
    const list = await getRedditTrending();
    if (!Array.isArray(list) || list.length === 0) return null;

    const upper = String(ticker).toUpperCase();
    const match = list.find(
      (item) => String(item.ticker || '').toUpperCase() === upper
    );

    return match || null;
  } catch (error) {
    console.error('Error fetching reddit buzz:', error);
    return null;
  }
};

// ===== View Count =====
export const recordViewCount = (ticker) => {
  if (!ticker) return;
  fetch(`${API_BASE_URL}/api/v1/open/stock-detail/${ticker}/view-count`, {
    method: 'POST',
  }).catch(() => {});
};

// ===== Polymarket Trends =====
export const getPolymarketEvents = async (order = 'volume_24hr', limitPerTag = 10) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/open/dashboard/polymarket/events?limitPerTag=${limitPerTag}&relatedTags=false&order=${order}`);
    return await response.json();
  } catch (error) {
    console.error('[getPolymarketEvents] error:', error);
    return null;
  }
};
